import {cn} from '@bem-react/classname';

export const cnObjectSelect = cn('ObjectSelect');
